import { useEffect, useState } from 'react';
import { bannerTexts } from 'v3/pages/LandingPage/config.ts';
import withResponsive from 'v3/common/hooks/withResponsive';
import Mobile from './mobile';
import Web from './web';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const ResponsiveComponent = withResponsive(Mobile, Web);

const { productName } = ApplicationDomainUtility;

const TextCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isShowing, setIsShowing] = useState(true);

  useEffect(() => {
    const cycle = setInterval(() => {
      setIsShowing(false);

      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % bannerTexts.length);
        setIsShowing(true);
      }, 800);
    }, 4000);

    return () => clearInterval(cycle);
  }, []);

  return (
    <div className="homepage-carousel-container">
      <ResponsiveComponent isShowing={isShowing} currentIndex={currentIndex} productName={productName} />
    </div>
  );
};

export default TextCarousel;
